module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/saledeed/soldproperty/soldproperty.component.html
// module id = ./src/app/allocation/saledeed/soldproperty/soldproperty.component.html
// module chunks = main